import type { LinkProps } from '@hover/blueprint';
import { Link } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

export interface LinkExternalProps extends Omit<LinkProps, 'children'> {
  /**
   * @deprecated Do not use this prop. It will be removed once the new branding
   * is fully implemented.
   * @see https://hoverinc.atlassian.net/wiki/x/PYCaxg
   */
  useNextStyle?: boolean;
  children?: ReactNode;
}

const LinkExternal = ({
  children,
  useNextStyle = false,
  ...props
}: LinkExternalProps) => (
  <Link
    {...(useNextStyle
      ? {
          color: 'neutral.900',
          _active: { color: 'neutral.800', textDecorationColor: 'neutral.800' },
        }
      : {})}
    rel="noopener noreferrer"
    target="_blank"
    {...props}
  >
    {children ?? ''}
  </Link>
);

export { LinkExternal };
